/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./audio-tag-list.vue?vue&type=template&id=5132710d&scoped=true&"
import script from "./audio-tag-list.vue?vue&type=script&lang=ts&"
export * from "./audio-tag-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132710d",
  null
  
)

export default component.exports